<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.8672 61.8212L25.1182 39.4301C26.3565 34.1375 31.0776 30.3987 36.5131 30.3987H96.0183"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M92.8027 41.9546H109.848"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M99.3203 46.7588H116.085"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.8965 51.5632H104.125"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.1113 59.0588L93.695 59.1481C95.7072 59.2613 97.3028 60.8747 97.3921 62.8869L97.6302 68.1796"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.4718 93.7497C74.4648 93.7497 75.2697 92.9447 75.2697 91.9518C75.2697 90.9588 74.4648 90.1538 73.4718 90.1538C72.4788 90.1538 71.6738 90.9588 71.6738 91.9518C71.6738 92.9447 72.4788 93.7497 73.4718 93.7497Z"
            class="primary-fill primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.4199 49.5391V54.3435"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.6831 48.0984H79.4738C78.9575 48.0984 78.5391 48.5169 78.5391 49.0331V49.0867C78.5391 49.6029 78.9575 50.0214 79.4738 50.0214H84.6831C85.1993 50.0214 85.6178 49.6029 85.6178 49.0867V49.0331C85.6178 48.5169 85.1993 48.0984 84.6831 48.0984Z"
            class="primary-fill primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.3024 59.0645C92.3024 59.0645 86.6347 58.9812 82.3244 58.9812C78.0141 58.9812 78.2522 62.9641 78.2522 62.9641C78.2522 62.9641 77.8831 91.4515 78.1093 91.2253L76.0613 91.0526C73.6561 90.8502 71.8105 88.8379 71.8105 86.4268V64.768C71.8105 61.8508 74.1741 59.4872 77.0913 59.4872"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M97.7664 71.9958C98.0521 87.2487 99.9513 91.4757 84.9783 91.7555H83.2637"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M96.423 93.8095C97.4159 93.8095 98.2209 93.0046 98.2209 92.0116C98.2209 91.0186 97.4159 90.2136 96.423 90.2136C95.43 90.2136 94.625 91.0186 94.625 92.0116C94.625 93.0046 95.43 93.8095 96.423 93.8095Z"
            class="primary-fill primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M80.712 94.5651C81.705 94.5651 82.51 93.7602 82.51 92.7672C82.51 91.7742 81.705 90.9692 80.712 90.9692C79.719 90.9692 78.9141 91.7742 78.9141 92.7672C78.9141 93.7602 79.719 94.5651 80.712 94.5651Z"
            class="primary-fill primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.7988 49.7476V56.5226"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M45.1439 82.9682C48.6028 82.9682 51.4188 85.7842 51.4188 89.2432C51.4188 92.7022 48.6028 95.5182 45.1439 95.5182C41.6849 95.5182 38.8689 92.7022 38.8689 89.2432C38.8689 85.7842 41.6849 82.9682 45.1439 82.9682ZM45.1439 80.8845C40.5239 80.8845 36.7852 84.6293 36.7852 89.2432C36.7852 93.8572 40.5299 97.6019 45.1439 97.6019C49.7578 97.6019 53.5026 93.8572 53.5026 89.2432C53.5026 84.6293 49.7578 80.8845 45.1439 80.8845Z"
            class="primary-fill" />
        <path
            d="M45.1436 86.9392C46.4117 86.9392 47.4476 87.9751 47.4476 89.2432C47.4476 89.7373 47.2928 90.2136 46.9951 90.6125C46.5546 91.2078 45.8818 91.5472 45.1436 91.5472C43.8755 91.5472 42.8396 90.5172 42.8396 89.2432C42.8396 88.2906 43.4409 87.4214 44.3339 87.088C44.5899 86.9928 44.8638 86.9451 45.1436 86.9451M45.1436 84.8555C44.6018 84.8555 44.0839 84.9567 43.6016 85.1353C41.9406 85.7604 40.7559 87.3619 40.7559 89.2432C40.7559 91.6663 42.7205 93.6309 45.1436 93.6309C46.5903 93.6309 47.8703 92.9344 48.668 91.8508C49.2098 91.1245 49.5253 90.2196 49.5253 89.2432C49.5253 86.8201 47.5607 84.8555 45.1376 84.8555H45.1436Z"
            class="primary-fill" />
        <path
            d="M60.9567 92.095H55.1759C55.1759 92.0653 55.1878 92.0295 55.1997 91.9998C55.4438 91.077 55.5748 90.1006 55.5629 89.0945C55.5093 85.1533 53.2351 81.736 49.9487 80.0095C48.4723 79.2295 46.7755 78.8009 44.9895 78.8188C43.3046 78.8485 41.721 79.2712 40.316 80.0095C36.9939 81.7538 34.7316 85.2366 34.7316 89.2433C34.7316 90.1959 34.8507 91.1187 35.0948 91.9998C35.1067 92.0295 35.1067 92.0653 35.1186 92.095H23.6462C21.5149 92.095 19.7586 90.4459 19.6038 88.3146C19.2704 82.2837 19.0858 78.8009 19.1216 72.4426C19.1752 68.1977 19.3776 63.816 19.9015 59.8748"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M18.1814 78.3125H19.9853C20.6581 78.3125 21.2058 78.8602 21.2058 79.533V85.5877C21.2058 86.2604 20.6581 86.8081 19.9853 86.8081H18.1814C17.5087 86.8081 16.9609 86.2604 16.9609 85.5877V79.533C16.9609 78.8602 17.5087 78.3125 18.1814 78.3125Z"
            class="primary-fill" />
        <path
            d="M16.6924 40.1921L15.3291 40.0612L14.9123 40.0195C14.3586 39.9659 13.8585 40.341 13.7514 40.8887L11.9296 50.3012C11.8105 50.9263 12.2511 51.5157 12.8881 51.5812L15.5136 51.8312C16.103 51.8907 16.6329 51.4561 16.6865 50.8608L17.5914 41.365C17.645 40.7934 17.2461 40.2874 16.6865 40.1981L16.6924 40.1921Z"
            class="primary-fill" />
        <path
            d="M47.0842 41.526C47.1378 40.7044 46.4829 40.0078 45.6613 40.0078H39.1363C34.9391 40.0078 32.0457 43.3358 31.5337 47.6104L30.0215 66.1853C29.9679 66.8223 30.4739 67.3641 31.111 67.3641H44.4825C45.0481 67.3641 45.5125 66.9235 45.5482 66.3639L47.0901 41.52L47.0842 41.526Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M20.1152 73.9365H65.5642"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M90.332 65.4231V84.9863"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.6289 65.4231V84.9863"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M15.5137 41.5315L16.1447 38.2154C16.6091 35.7744 18.7405 34.0122 21.2231 34.0122H24.4141"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
